<div class="tp-micro-wrapper flex align--center justify--center spacing-min-lg">
  <sales-trustbox [trustBoxType]="TrustBox.MICRO"></sales-trustbox>
</div>
